import * as constants from "../constants/cinemaCurrentConstants";
import actionCreators from "../../../itemList/actions/tabbedMoviesActionCreators";

export default actionCreators(constants);
